export function defaultNewFloorTimeZone({
  parentBuildingTimeZone,
  existingFloorTimeZone,
  browserTimeZone,
}: {
  parentBuildingTimeZone?: string | null;
  existingFloorTimeZone?: string | null;
  browserTimeZone: string;
}): string {
  if (existingFloorTimeZone) return existingFloorTimeZone;
  if (parentBuildingTimeZone) return parentBuildingTimeZone;
  return browserTimeZone;
}
